import httpClient from "@/services";
import { API_ENDPOINTS } from "@/services/endpoints";
import type {
  PaperlessEobFetchRequest,
  PaperlessEobUpdateRequest,
} from "@/model/paperlessEob";

export const fetchPaperlessEob = async (
  fetchReqData: PaperlessEobFetchRequest,
) => {
  const url = `${
    API_ENDPOINTS.PAPERLESS_EOB.FETCH
  }/${fetchReqData.groupId}/${fetchReqData.memberId}`;
  const config = {
    headers: {
      Authorization: `Bearer ${fetchReqData.accessToken}`,
    },
  };
  return httpClient.get(url, config).then((res) => res.data);
};

export const updatePaperlessEob = async (
  updateReqData: PaperlessEobUpdateRequest,
) => {
  const url = API_ENDPOINTS.PAPERLESS_EOB.UPDATE;

  const data = {
    groupId: updateReqData.groupId,
    memberId: updateReqData.memberId,
    action: updateReqData.action,
  };

  const config = {
    headers: {
      Authorization: `Bearer ${updateReqData.accessToken}`,
    },
  };

  return httpClient.post(url, data, config).then((res) => res.data);
};
